import { GetEvaluationDocument, GetEvaluationQuery } from '@/api/queries';

import { GetEvaluationInput } from '@/models/gen/graphql';
import graphApi from '@/api';

const [_, runGetEvaluation] = graphApi(GetEvaluationDocument);

export const getEvaluation = async (evaluationId: string): Promise<GetEvaluationQuery['getEvaluation']['evaluation']> => {
  const input: GetEvaluationInput = { evaluationId };
  const res = await runGetEvaluation({ input });

  return res?.getEvaluation?.evaluation;
};
